module.exports = __webpack_public_path__ + "img/cjc1_style_2_font_sprite.530d79cc.webp";